import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE, KEYBOARD_SHORTCUTS } from '../../constants';
import CmButton from '../../components/primitives/CmButton';
import KeyboardHint from '../../components/KeyboardHint/KeyboardHint';
import styles from './review.module.css';

export interface StickyActionBarProps {
  onApprove: () => void;
  onBlock: () => void;
  onSkip: () => void;
  disabled?: boolean;
  testId?: string;
}

export function StickyActionBar({
  onApprove,
  onBlock,
  onSkip,
  disabled = false,
  testId,
}: StickyActionBarProps): React.ReactElement {
  return (
    <div className={styles.actionBar} data-testid={testId}>
      <div className={styles.actionBarKeys}>
        {I18n.t(`${I18N_BASE}.detail.actions.keyboardHints`)}
        <KeyboardHint keyName={KEYBOARD_SHORTCUTS.approve.toUpperCase()} />
        <KeyboardHint keyName={KEYBOARD_SHORTCUTS.block.toUpperCase()} />
        <KeyboardHint keyName={KEYBOARD_SHORTCUTS.skip.toUpperCase()} />
      </div>
      <div className={styles.actionBarButtons}>
        <CmButton
          variant="ghost"
          onClick={onSkip}
          disabled={disabled}
          testId="action-skip"
        >
          {I18n.t(`${I18N_BASE}.detail.actions.skip`)}
        </CmButton>
        <CmButton
          variant="primary"
          onClick={onApprove}
          disabled={disabled}
          testId="action-approve"
        >
          {I18n.t(`${I18N_BASE}.detail.actions.approve`)}
        </CmButton>
        <CmButton
          variant="danger"
          onClick={onBlock}
          disabled={disabled}
          testId="action-block"
        >
          {I18n.t(`${I18N_BASE}.detail.actions.block`)}
        </CmButton>
      </div>
    </div>
  );
}

export default StickyActionBar;
